import { ref } from 'vue'

// Topbar title/breadcrumbs. The base comes from route.meta (pageTitle/crumbs),
// detail pages can override them dynamically (order number, locker name).
const titleOverride = ref(null)
const crumbsOverride = ref(null)

export function usePageHeader() {
  const setPageTitle = (title) => { titleOverride.value = title }
  const setPageCrumbs = (crumbs) => { crumbsOverride.value = crumbs }
  const resetPageHeader = () => {
    titleOverride.value = null
    crumbsOverride.value = null
  }

  return { titleOverride, crumbsOverride, setPageTitle, setPageCrumbs, resetPageHeader }
}
